<administration></administration>
<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  fxFlexFill
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="onMainTabChange($event)"
>
  <mat-tab label="Gopher Buddy Setup">
    <div class="tab-content">
      <gopher-buddy-setup [ouTreeData]="ouTreeData"></gopher-buddy-setup>
    </div>
  </mat-tab>
  <!-- Hidden for now, deprecate or bring back in later phases -->
  <!-- <mat-tab label="Device Cache">
    <div class="tab-content">
      <device-cache></device-cache>
    </div>
  </mat-tab> -->
  <mat-tab label="Time Zone & Date Format">
    <div class="tab-content">
      <time-zone-date-format></time-zone-date-format>
    </div>
  </mat-tab>
  <!-- <mat-tab label="Licensing Contacts">
    <div class="tab-content">
      <licensing-contacts></licensing-contacts>
    </div>
  </mat-tab> -->
</mat-tab-group>